export default "__VITE_ASSET__BUC6$fp4__"